import Resource from './Resource';

/**
 * Consumable Resource
 */
class Consumable extends Resource
{
    constructor() {
        super('accounting.consumable', ['consumables']);
    }
}   

export let ConsumableResource = new Consumable();